import apiClient from './apiClient';

export const customerDashboardService = {
    // Get comprehensive dashboard statistics
    getDashboardStats: async (params = {}) => {
        try {
            const response = await apiClient.get('/customer/dashboard/stats', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get customer's active shipments
    getActiveShipments: async () => {
        try {
            const response = await apiClient.get('/customer/dashboard/active-shipments');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get customer's recent activity
    getRecentActivity: async (limit = 10) => {
        try {
            const response = await apiClient.get('/customer/dashboard/recent-activity', {
                params: { limit }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get customer's shipment summary
    getShipmentSummary: async (params = {}) => {
        try {
            const response = await apiClient.get('/customer/dashboard/shipment-summary', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};
